// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-right-s"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.7344 8.46448L14.2699 12L10.7344 15.5355","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronRightSIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-right-s',
    ref,
    icon: element,
  },
));

ChevronRightSIcon.displayName = 'ChevronRightSIcon';

export default ChevronRightSIcon;
